import type { IconData } from '@stacksjs/iconify-core'

export const windowMinimize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M48 448h416v32H48z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default windowMinimize
